import { render, staticRenderFns } from "./AppartmentBloc.vue?vue&type=template&id=66a5594e&scoped=true&"
import script from "./AppartmentBloc.vue?vue&type=script&lang=js&"
export * from "./AppartmentBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5594e",
  null
  
)

export default component.exports